<template>
  <nav class="menu-container">
    <h3><font color="#DB6D1C">2号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "chiwan",
          title: "赤湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shekougang",
          title: "蛇口港",
          // icon: "chat",
          exact: true,
        },
        {
          name: "haishangshijie",
          title: "海上世界",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shuiwan",
          title: "水湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dongjiaotou",
          title: "东角头",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wanxia",
          title: "湾厦",
          // icon: "chat",
          exact: true,
        },
        {
          name: "haiyue",
          title: "海月",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dengliang",
          title: "登良",
          // icon: "chat",
          exact: true,
        },
        {
          name: "houhai",
          title: "后海",
          // icon: "chat",
          exact: true,
        },
        {
          name: "keyuan",
          title: "科苑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hongshuwan",
          title: "红树湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shijiezhichuang",
          title: "世界之窗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qiaochengbei",
          title: "侨城北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenkang",
          title: "深康",
          // icon: "chat",
          exact: true,
        },
        {
          name: "antuoshan",
          title: "安托山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qiaoxiang",
          title: "侨香",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xiangmi",
          title: "香蜜",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xiangmeibei",
          title: "香梅北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jingtian",
          title: "景田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "lianhuaxi",
          title: "莲花西",
          // icon: "chat",
          exact: true,
        },
        {
          name: "futian",
          title: "福田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiminzhongxin",
          title: "市民中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gangxiabei",
          title: "岗厦北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaqiangbei",
          title: "华强北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yannan",
          title: "燕南",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dajuyuan",
          title: "大剧院",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hubei",
          title: "湖贝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huangbeiling",
          title: "黄贝岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xinxiu",
          title: "新秀",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liantangkouan",
          title: "莲塘口岸",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xianhulu",
          title: "仙湖路",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liantang",
          title: "莲塘",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!--

  首页
深圳地铁2号线 途经站点 共32站
注：2号线与8号线贯通运行，2号线的莲塘站下一个站点即8号线的梧桐山南站,原本的2号线新秀方向更改为8号线盐田路方向。高峰和平峰，车次间隔均为8分钟左右。

赤湾站-蛇口港站-海上世界站-水湾站-东角头站-湾厦站-海月站-登良站-后海站-科苑站-红树湾站- 世界之窗站-侨城北站-深康站-安托山站-侨香站-香蜜站-香梅北站-景田站-莲花西站-福田站- 市民中心站-岗厦北站-华强北站-燕南站-大剧院站-湖贝站-黄贝岭站-新秀站-莲塘口岸站-仙湖路站- 莲塘站

 -->